var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockwiseDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 4.37096C20 3.88994 19.614 3.5 19.1379 3.5C18.6619 3.5 18.2759 3.88994 18.2759 4.37096V6.20545C15.6328 3.47228 11.4957 2.69182 8.00391 4.4125C3.58303 6.59098 1.74716 11.9778 3.90336 16.4444C6.05957 20.9109 11.3913 22.7658 15.8122 20.5873C17.5778 19.7173 18.9913 18.3021 19.866 16.5407C20.0795 16.1108 19.9076 15.5874 19.4821 15.3717C19.0566 15.156 18.5385 15.3296 18.325 15.7596C17.6195 17.1802 16.4815 18.3194 15.0564 19.0217C11.4914 20.7784 7.19176 19.2827 5.45298 15.6808C3.71419 12.0789 5.19466 7.73488 8.7597 5.97812C11.8857 4.43772 15.6172 5.39244 17.6546 8.14511H14.5403C14.0642 8.14511 13.6783 8.53505 13.6783 9.01607C13.6783 9.49709 14.0642 9.88703 14.5403 9.88703H19.1379C19.614 9.88703 20 9.49709 20 9.01607V8.95065C20.0002 8.93671 20 4.37096 20 4.37096Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockwiseDirection);
export default __webpack_public_path__ + "static/media/clockwise-direction.8b19acbdea3f7d753aed3606cc47ea7d.svg";
export { ForwardRef as ReactComponent };